import type { Video } from '@/types/video';

export const videos: Video[] = [
  {
    id: 'movie-01',
    title: '星际迷航：无垠边界',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20film%20still%20of%20a%20lone%20astronaut%20standing%20before%20a%20giant%20glowing%20space%20station%20window%2C%20deep%20blue%20nebula%20and%20warm%20orange%20engine%20glow%2C%20epic%20scale%2C%20dramatic%20lighting%2C%20photorealistic&width=800&height=450&seq=mv-01&orientation=landscape',
    duration: '02:18:40',
    uploadDate: '2025-09-28',
    category: 'movie',
    categoryName: '电影',
    region: '美国',
    year: 2025,
    genre: '科幻',
    tags: ['太空', '冒险', '视效大片'],
    description: '一支失联多年的探索舰队在银河边缘重启信号，年轻领航员必须带领队员穿越未知星域，揭开人类文明起源的惊人真相。',
    views: 1286000,
  },
  {
    id: 'movie-02',
    title: '沉默的真相',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20noir%20film%20still%20of%20a%20detective%20in%20a%20rainy%20alley%20at%20night%2C%20streetlight%20reflection%20on%20wet%20asphalt%2C%20moody%20teal%20and%20amber%20tones%2C%20suspenseful%20atmosphere%2C%20film%20grain&width=800&height=450&seq=mv-02&orientation=landscape',
    duration: '01:52:10',
    uploadDate: '2025-09-21',
    category: 'movie',
    categoryName: '电影',
    region: '中国大陆',
    year: 2025,
    genre: '悬疑',
    tags: ['犯罪', '推理', '反转'],
    description: '一桩尘封十年的旧案因一段匿名录音重新浮出水面，执着的老刑警与年轻检察官联手追查，真相远比想象更沉重。',
    views: 986000,
  },
  {
    id: 'movie-03',
    title: '长安三万里',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20historical%20film%20still%20of%20ancient%20chinese%20city%20at%20dusk%20with%20lanterns%20and%20pagodas%2C%20warm%20golden%20light%2C%20ink%20painting%20aesthetic%2C%20epic%20sweeping%20view%2C%20rich%20detail&width=800&height=450&seq=mv-03&orientation=landscape',
    duration: '02:24:05',
    uploadDate: '2025-09-15',
    category: 'movie',
    categoryName: '电影',
    region: '中国大陆',
    year: 2024,
    genre: '历史',
    tags: ['史诗', '武侠', '国风'],
    description: '盛唐气象下，一群意气风发的诗人与将帅在时代洪流中起伏沉浮，用一生书写出流传千古的豪情与怅惘。',
    views: 1542000,
  },
  {
    id: 'movie-04',
    title: '深海回声',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20underwater%20film%20still%20of%20a%20submarine%20descending%20into%20dark%20ocean%20trench%2C%20bioluminescent%20particles%20floating%2C%20single%20warm%20headlight%20beam%2C%20tense%20atmosphere%2C%20photorealistic&width=800&height=450&seq=mv-04&orientation=landscape',
    duration: '01:44:30',
    uploadDate: '2025-09-08',
    category: 'movie',
    categoryName: '电影',
    region: '英国',
    year: 2024,
    genre: '惊悚',
    tags: ['深海', '生存', '密闭空间'],
    description: '深海勘探潜艇在万米海沟遭遇不明信号，氧气与时间同时告急，船员们必须在黑暗中做出最残酷的抉择。',
    views: 723000,
  },
  {
    id: 'movie-05',
    title: '追风者',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20sports%20film%20still%20of%20a%20cyclist%20racing%20down%20a%20mountain%20road%20at%20sunrise%2C%20motion%20blur%2C%20warm%20orange%20sky%2C%20dust%20and%20determination%2C%20dynamic%20angle&width=800&height=450&seq=mv-05&orientation=landscape',
    duration: '01:38:15',
    uploadDate: '2025-08-30',
    category: 'movie',
    categoryName: '电影',
    region: '中国大陆',
    year: 2025,
    genre: '剧情',
    tags: ['热血', '竞技', '励志'],
    description: '一名被车队除名的年轻骑手带着满腔不甘重新出发，在高原赛道上与最强的对手和自己赛跑。',
    views: 654000,
  },
  {
    id: 'movie-06',
    title: '归途列车',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20an%20old%20train%20crossing%20a%20snowy%20countryside%20at%20night%2C%20warm%20lit%20windows%2C%20cold%20blue%20snow%2C%20nostalgic%20warm%20mood%2C%20soft%20falling%20snow&width=800&height=450&seq=mv-06&orientation=landscape',
    duration: '02:01:50',
    uploadDate: '2025-08-22',
    category: 'movie',
    categoryName: '电影',
    region: '中国大陆',
    year: 2024,
    genre: '剧情',
    tags: ['家庭', '温情', '公路'],
    description: '春运的列车上，素不相识的旅客因一场暴雪被迫同行，一段意外的旅程让每个人都想起了要回去的地方。',
    views: 512000,
  },
  {
    id: 'movie-07',
    title: '城市之光',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20neon%20lit%20city%20skyline%20at%20night%20reflected%20on%20a%20river%2C%20warm%20orange%20and%20cyan%20lights%2C%20lone%20figure%20on%20a%20bridge%2C%20urban%20romance%20mood&width=800&height=450&seq=mv-07&orientation=landscape',
    duration: '01:56:20',
    uploadDate: '2025-08-14',
    category: 'movie',
    categoryName: '电影',
    region: '中国香港',
    year: 2025,
    genre: '爱情',
    tags: ['都市', '浪漫', '夜景'],
    description: '两个在都市深夜加班的人通过一面意外亮起的霓虹招牌相识，在钢筋水泥的森林里寻找属于彼此的那束光。',
    views: 431000,
  },
  {
    id: 'movie-08',
    title: '雪山之巅',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20adventure%20film%20still%20of%20climbers%20ascending%20a%20snow%20peak%20at%20dawn%2C%20golden%20sunrise%20light%20on%20snow%2C%20dramatic%20clouds%20below%2C%20heroic%20scale%2C%20photorealistic&width=800&height=450&seq=mv-08&orientation=landscape',
    duration: '02:12:00',
    uploadDate: '2025-08-06',
    category: 'movie',
    categoryName: '电影',
    region: '美国',
    year: 2024,
    genre: '冒险',
    tags: ['登山', '极限', '真实改编'],
    description: '五位登山者挑战从未有人登顶的北壁，在暴风雪与缺氧中，他们不仅要战胜山峰，更要战胜内心的恐惧。',
    views: 689000,
  },
  {
    id: 'movie-09',
    title: '暗夜行者',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20action%20film%20still%20of%20a%20lone%20figure%20in%20a%20long%20coat%20walking%20down%20a%20foggy%20street%2C%20backlit%20by%20orange%20street%20lamps%2C%20moody%20dark%20tones%2C%20mysterious%20tension&width=800&height=450&seq=mv-09&orientation=landscape',
    duration: '01:48:35',
    uploadDate: '2025-07-29',
    category: 'movie',
    categoryName: '电影',
    region: '韩国',
    year: 2025,
    genre: '动作',
    tags: ['卧底', '犯罪', '高能'],
    description: '潜伏多年的卧底警察身份即将暴露，在这座不眠之城的最后一夜，他必须做出忠于职责还是忠于良心的选择。',
    views: 803000,
  },
  {
    id: 'movie-10',
    title: '时光信笺',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20romantic%20film%20still%20of%20a%20wooden%20desk%20with%20handwritten%20letters%20and%20dried%20flowers%2C%20warm%20afternoon%20sunlight%20through%20lace%20curtain%2C%20soft%20nostalgic%20mood&width=800&height=450&seq=mv-10&orientation=landscape',
    duration: '01:59:45',
    uploadDate: '2025-07-20',
    category: 'movie',
    categoryName: '电影',
    region: '日本',
    year: 2024,
    genre: '爱情',
    tags: ['治愈', '时空', '书信'],
    description: '一间老旧书店里的信箱能寄信给过去的自己，一段跨越十年的通信，让两个错过的人重新审视彼此的心意。',
    views: 498000,
  },
  {
    id: 'movie-11',
    title: '荒原猎人',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20western%20film%20still%20of%20a%20lone%20hunter%20riding%20across%20a%20vast%20desert%20at%20sunset%2C%20long%20shadows%2C%20dusty%20orange%20sky%2C%20gritty%20textured%20atmosphere&width=800&height=450&seq=mv-11&orientation=landscape',
    duration: '02:06:10',
    uploadDate: '2025-07-11',
    category: 'movie',
    categoryName: '电影',
    region: '美国',
    year: 2023,
    genre: '西部',
    tags: ['复仇', '荒野', '孤胆'],
    description: '边陲小镇被一群亡命之徒笼罩，沉默的赏金猎人带着一纸旧约归来，用最残酷的方式讨回属于自己的公道。',
    views: 366000,
  },
  {
    id: 'movie-12',
    title: '霓虹之下',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20cyberpunk%20film%20still%20of%20a%20crowded%20street%20market%20drenched%20in%20neon%20signs%20and%20rain%2C%20reflections%20everywhere%2C%20warm%20orange%20and%20magenta%20glow%2C%20futuristic%20mood&width=800&height=450&seq=mv-12&orientation=landscape',
    duration: '01:51:25',
    uploadDate: '2025-07-03',
    category: 'movie',
    categoryName: '电影',
    region: '中国大陆',
    year: 2025,
    genre: '科幻',
    tags: ['赛博朋克', '未来', '反乌托邦'],
    description: '在记忆可以被买卖的未来都市，一名落魄的侦探受雇寻找一段被删除的记忆，却一步步陷入更大的阴谋。',
    views: 742000,
  },
  {
    id: 'movie-13',
    title: '大航海时代',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20adventure%20film%20still%20of%20a%20tall%20sailing%20ship%20on%20stormy%20open%20seas%2C%20dramatic%20waves%2C%20sunset%20light%20through%20clouds%2C%20epic%20maritime%20scale%2C%20photorealistic&width=800&height=450&seq=mv-13&orientation=landscape',
    duration: '02:31:00',
    uploadDate: '2025-06-24',
    category: 'movie',
    categoryName: '电影',
    region: '英国',
    year: 2024,
    genre: '冒险',
    tags: ['航海', '探索', '史诗'],
    description: '一群不被看好的水手驾驶一艘旧船驶向地图之外的海洋，风暴、疾病与未知的陆地考验着每个人的信仰。',
    views: 559000,
  },
  {
    id: 'movie-14',
    title: '最后一封情书',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20drama%20film%20still%20of%20an%20elderly%20couple%20sitting%20on%20a%20bench%20in%20an%20autumn%20park%2C%20warm%20golden%20leaves%2C%20tender%20emotional%20mood%2C%20soft%20bokeh%20background&width=800&height=450&seq=mv-14&orientation=landscape',
    duration: '01:47:40',
    uploadDate: '2025-06-15',
    category: 'movie',
    categoryName: '电影',
    region: '法国',
    year: 2023,
    genre: '剧情',
    tags: ['亲情', '回忆', '催泪'],
    description: '一位老人在生命最后的日子里坚持写下给妻子的最后一封信，字里行间藏着半个世纪的相守与未说出口的歉意。',
    views: 402000,
  },
  {
    id: 'movie-15',
    title: '机械之心',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20film%20still%20of%20a%20humanoid%20robot%20with%20glowing%20orange%20core%20in%20a%20dark%20laboratory%2C%20detailed%20mechanical%20parts%2C%20soft%20rim%20light%2C%20elegant%20futuristic%20design&width=800&height=450&seq=mv-15&orientation=landscape',
    duration: '02:03:55',
    uploadDate: '2025-06-06',
    category: 'movie',
    categoryName: '电影',
    region: '美国',
    year: 2025,
    genre: '科幻',
    tags: ['人工智能', '伦理', '温情'],
    description: '一台拥有自我意识的家用机器人开始理解人类的情感，它的工程师却在公司压力下必须将它重置，一段关于存在的选择就此展开。',
    views: 875000,
  },
  {
    id: 'movie-16',
    title: '雨林秘境',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20adventure%20film%20still%20of%20a%20dense%20tropical%20rainforest%20with%20sunbeams%20through%20canopy%2C%20ancient%20stone%20ruins%2C%20lush%20green%20tones%2C%20mysterious%20discovery%20atmosphere&width=800&height=450&seq=mv-16&orientation=landscape',
    duration: '01:58:30',
    uploadDate: '2025-05-27',
    category: 'movie',
    categoryName: '电影',
    region: '巴西',
    year: 2023,
    genre: '冒险',
    tags: ['探索', '秘境', '解谜'],
    description: '一支考古队深入亚马逊腹地寻找失落的文明，却在雨林深处发现了一个不该存在于任何地图上的古代遗迹。',
    views: 318000,
  },
  {
    id: 'movie-17',
    title: '北境之光',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20drama%20film%20still%20of%20a%20small%20fishing%20village%20under%20green%20aurora%20borealis%20at%20night%2C%20snow%20covered%20roofs%2C%20warm%20window%20glow%2C%20serene%20cold%20beauty&width=800&height=450&seq=mv-17&orientation=landscape',
    duration: '02:09:15',
    uploadDate: '2025-05-18',
    category: 'movie',
    categoryName: '电影',
    region: '挪威',
    year: 2024,
    genre: '剧情',
    tags: ['极地', '成长', '人文'],
    description: '极夜笼罩的北方渔村，一个少年在失去父亲后决定独自守护家族的小船，极光之下他学会了与孤独和解。',
    views: 287000,
  },
  {
    id: 'movie-18',
    title: '沉默的证词',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20courtroom%20drama%20film%20still%20of%20a%20tense%20hearing%20with%20a%20lone%20witness%2C%20dramatic%20side%20lighting%2C%20muted%20tones%2C%20serious%20atmospheric%20mood&width=800&height=450&seq=mv-18&orientation=landscape',
    duration: '01:55:00',
    uploadDate: '2025-05-09',
    category: 'movie',
    categoryName: '电影',
    region: '中国大陆',
    year: 2024,
    genre: '悬疑',
    tags: ['法庭', '人性', '博弈'],
    description: '一场看似证据确凿的庭审，因唯一目击者始终不肯开口而陷入僵局，真相在控辩双方的博弈中逐渐浮现。',
    views: 445000,
  },
  {
    id: 'movie-19',
    title: '第七个夏天',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20coming-of-age%20film%20still%20of%20teenagers%20cycling%20through%20sunlit%20countryside%20in%20summer%2C%20lush%20green%20fields%2C%20warm%20nostalgic%20golden%20light%2C%20joyful%20youth%20mood&width=800&height=450&seq=mv-19&orientation=landscape',
    duration: '01:49:20',
    uploadDate: '2025-04-30',
    category: 'movie',
    categoryName: '电影',
    region: '日本',
    year: 2023,
    genre: '青春',
    tags: ['成长', '夏天', '友情'],
    description: '七个小城少年约定在每个夏天聚首，随着最后一个夏天到来，他们不得不面对离别、梦想与悄然改变的未来。',
    views: 356000,
  },
  {
    id: 'movie-20',
    title: '苍穹之下',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20disaster%20film%20still%20of%20a%20city%20skyline%20under%20a%20massive%20dramatic%20storm%20cloud%2C%20lightning%20in%20distance%2C%20people%20looking%20up%2C%20epic%20tense%20scale&width=800&height=450&seq=mv-20&orientation=landscape',
    duration: '02:16:45',
    uploadDate: '2025-04-21',
    category: 'movie',
    categoryName: '电影',
    region: '美国',
    year: 2025,
    genre: '灾难',
    tags: ['末日', '生存', '大场面'],
    description: '大气层异变让全球陷入永夜，一群科学家与普通人必须在有限的时间里找到重启阳光的方法，拯救人类最后的希望。',
    views: 1024000,
  },

  {
    id: 'short-01',
    title: '3分钟看懂量子力学',
    cover: 'https://readdy.ai/api/search-image?query=clean%20educational%20science%20thumbnail%20with%20glowing%20atom%20model%20and%20particle%20trails%20on%20dark%20gradient%20background%2C%20bright%20orange%20accent%20light%2C%20modern%20minimal%20design&width=800&height=450&seq=st-01&orientation=landscape',
    duration: '03:12',
    uploadDate: '2025-10-05',
    category: 'short',
    categoryName: '短视频',
    region: '中国大陆',
    year: 2025,
    genre: '科普',
    tags: ['物理', '知识', '动画'],
    description: '用最通俗的比喻带你三分钟理解量子叠加与纠缠，原来微观世界的奇妙并不遥远。',
    views: 2340000,
  },
  {
    id: 'short-02',
    title: '街头小吃巡礼',
    cover: 'https://readdy.ai/api/search-image?query=vibrant%20street%20food%20thumbnail%20of%20sizzling%20skewers%20and%20steaming%20noodles%20at%20a%20night%20market%2C%20warm%20orange%20lantern%20light%2C%20appetizing%20close-up%2C%20energetic%20mood&width=800&height=450&seq=st-02&orientation=landscape',
    duration: '05:48',
    uploadDate: '2025-10-04',
    category: 'short',
    categoryName: '短视频',
    region: '中国大陆',
    year: 2025,
    genre: '美食',
    tags: ['美食', '探店', '夜市'],
    description: '跟着镜头穿越大街小巷，一口气打卡十家藏在夜市深处的宝藏小吃摊，每一口都是人间烟火。',
    views: 1876000,
  },
  {
    id: 'short-03',
    title: '一分钟学会折纸飞机',
    cover: 'https://readdy.ai/api/search-image?query=bright%20creative%20craft%20thumbnail%20of%20colorful%20paper%20airplanes%20flying%20over%20a%20clean%20warm%20background%2C%20soft%20studio%20lighting%2C%20playful%20minimal%20style&width=800&height=450&seq=st-03&orientation=landscape',
    duration: '01:05',
    uploadDate: '2025-10-03',
    category: 'short',
    categoryName: '短视频',
    region: '中国大陆',
    year: 2025,
    genre: '手工',
    tags: ['教程', '手工', '亲子'],
    description: '三种不同飞法的纸飞机折法全解析，跟着步骤一分钟就能做出飞得最远的那一架。',
    views: 964000,
  },
  {
    id: 'short-04',
    title: '猫咪的日常生活',
    cover: 'https://readdy.ai/api/search-image?query=adorable%20cat%20thumbnail%20of%20a%20fluffy%20orange%20tabby%20cat%20stretching%20in%20warm%20morning%20sunlight%20on%20a%20wooden%20floor%2C%20soft%20cozy%20tones%2C%20cute%20wholesome%20mood&width=800&height=450&seq=st-04&orientation=landscape',
    duration: '06:30',
    uploadDate: '2025-10-02',
    category: 'short',
    categoryName: '短视频',
    region: '日本',
    year: 2025,
    genre: '萌宠',
    tags: ['猫咪', '治愈', '日常'],
    description: '记录一只橘猫从清晨打哈欠到深夜入睡的完整一天，慢下来的治愈时光让人忍不住嘴角上扬。',
    views: 3120000,
  },
  {
    id: 'short-05',
    title: '城市夜景延时摄影',
    cover: 'https://readdy.ai/api/search-image?query=stunning%20timelapse%20thumbnail%20of%20a%20city%20skyscraper%20skyline%20at%20night%20with%20light%20trails%20on%20highways%2C%20warm%20orange%20and%20cool%20blue%20contrast%2C%20long%20exposure%20feel&width=800&height=450&seq=st-05&orientation=landscape',
    duration: '04:22',
    uploadDate: '2025-10-01',
    category: 'short',
    categoryName: '短视频',
    region: '中国大陆',
    year: 2025,
    genre: '摄影',
    tags: ['延时', '城市', '美学'],
    description: '连续七小时拍摄的城市夜景延时合集，从日落到日出，用光影讲述一座城市不眠的心跳。',
    views: 1258000,
  },
  {
    id: 'short-06',
    title: '健身入门七个动作',
    cover: 'https://readdy.ai/api/search-image?query=clean%20fitness%20thumbnail%20of%20a%20person%20doing%20a%20bodyweight%20workout%20in%20a%20bright%20simple%20gym%2C%20warm%20accent%20lighting%2C%20motivating%20energetic%20modern%20style&width=800&height=450&seq=st-06&orientation=landscape',
    duration: '08:15',
    uploadDate: '2025-09-30',
    category: 'short',
    categoryName: '短视频',
    region: '中国大陆',
    year: 2025,
    genre: '运动',
    tags: ['健身', '教程', '居家'],
    description: '零基础也能上手的七个居家健身动作，无器械、不伤膝，坚持两周就能感受到身体的变化。',
    views: 876000,
  },
  {
    id: 'short-07',
    title: '十分钟快手菜',
    cover: 'https://readdy.ai/api/search-image?query=appetizing%20cooking%20thumbnail%20of%20a%20colorful%20stir%20fry%20in%20a%20wok%20with%20steam%20rising%2C%20fresh%20vegetables%2C%20warm%20kitchen%20light%2C%20tasty%20home%20cooking%20mood&width=800&height=450&seq=st-07&orientation=landscape',
    duration: '10:40',
    uploadDate: '2025-09-29',
    category: 'short',
    categoryName: '短视频',
    region: '中国大陆',
    year: 2025,
    genre: '美食',
    tags: ['下厨', '快手', '家常菜'],
    description: '上班族下班后最需要的十分钟快手菜，从备料到出锅一气呵成，简单到新手也能一次成功。',
    views: 1432000,
  },
  {
    id: 'short-08',
    title: '耳机改装教程',
    cover: 'https://readdy.ai/api/search-image?query=detailed%20tech%20thumbnail%20of%20disassembled%20headphones%20with%20small%20tools%20on%20a%20warm%20wooden%20workbench%2C%20soft%20focused%20lighting%2C%20precision%20handcraft%20mood&width=800&height=450&seq=st-08&orientation=landscape',
    duration: '07:55',
    uploadDate: '2025-09-28',
    category: 'short',
    categoryName: '短视频',
    region: '中国大陆',
    year: 2025,
    genre: '数码',
    tags: ['数码', 'DIY', '评测'],
    description: '花小钱让旧耳机重获新生，从更换线材到调整调音，手把手教你完成一次靠谱的耳机改装。',
    views: 534000,
  },
  {
    id: 'short-09',
    title: '露营装备开箱',
    cover: 'https://readdy.ai/api/search-image?query=outdoor%20camping%20thumbnail%20of%20a%20tent%20and%20gear%20set%20up%20at%20golden%20hour%20in%20a%20lakeside%20meadow%2C%20warm%20sunlight%2C%20cozy%20adventure%20atmosphere&width=800&height=450&seq=st-09&orientation=landscape',
    duration: '12:20',
    uploadDate: '2025-09-27',
    category: 'short',
    categoryName: '短视频',
    region: '中国大陆',
    year: 2025,
    genre: '户外',
    tags: ['露营', '开箱', '装备'],
    description: '一整套轻量化露营装备开箱实测，从帐篷到炉具逐件点评，帮你避开新手最容易踩的坑。',
    views: 692000,
  },
  {
    id: 'short-10',
    title: '手机摄影技巧',
    cover: 'https://readdy.ai/api/search-image?query=creative%20photography%20thumbnail%20of%20a%20hand%20holding%20a%20smartphone%20framing%20a%20sunset%20street%20scene%2C%20warm%20golden%20light%2C%20modern%20clean%20aesthetic&width=800&height=450&seq=st-10&orientation=landscape',
    duration: '09:10',
    uploadDate: '2025-09-26',
    category: 'short',
    categoryName: '短视频',
    region: '中国大陆',
    year: 2025,
    genre: '摄影',
    tags: ['手机', '构图', '技巧'],
    description: '不用专业相机，学会这五个手机摄影小技巧，随手一拍也能拍出让人点赞的大片质感。',
    views: 1105000,
  },
  {
    id: 'short-11',
    title: '手冲咖啡全流程',
    cover: 'https://readdy.ai/api/search-image?query=aesthetic%20coffee%20thumbnail%20of%20pour%20over%20coffee%20brewing%20with%20a%20gooseneck%20kettle%2C%20warm%20wooden%20counter%2C%20soft%20morning%20light%2C%20cozy%20artisanal%20mood&width=800&height=450&seq=st-11&orientation=landscape',
    duration: '06:48',
    uploadDate: '2025-09-25',
    category: 'short',
    categoryName: '短视频',
    region: '中国大陆',
    year: 2025,
    genre: '生活',
    tags: ['咖啡', '手冲', '生活美学'],
    description: '从研磨度到水温再到注水节奏，完整演示一杯手冲咖啡的制作流程，让每个清晨都值得期待。',
    views: 758000,
  },
  {
    id: 'short-12',
    title: '骑行穿越海岸线',
    cover: 'https://readdy.ai/api/search-image?query=scenic%20cycling%20thumbnail%20of%20a%20road%20bike%20on%20a%20winding%20coastal%20road%20at%20sunset%2C%20ocean%20waves%20below%2C%20warm%20orange%20sky%2C%20freedom%20adventure%20mood&width=800&height=450&seq=st-12&orientation=landscape',
    duration: '15:30',
    uploadDate: '2025-09-24',
    category: 'short',
    categoryName: '短视频',
    region: '中国台湾',
    year: 2025,
    genre: '旅行',
    tags: ['骑行', '海岸', '旅行'],
    description: '用三天时间骑行三百公里海岸公路，沿途的灯塔、渔村与日落，是属于自由的浪漫答案。',
    views: 812000,
  },
  {
    id: 'short-13',
    title: '极简桌搭分享',
    cover: 'https://readdy.ai/api/search-image?query=minimal%20desk%20setup%20thumbnail%20of%20a%20clean%20wooden%20desk%20with%20laptop%2C%20plant%20and%20warm%20lamp%2C%20soft%20natural%20light%2C%20tidy%20aesthetic%20workspace&width=800&height=450&seq=st-13&orientation=landscape',
    duration: '08:05',
    uploadDate: '2025-09-23',
    category: 'short',
    categoryName: '短视频',
    region: '中国大陆',
    year: 2025,
    genre: '生活',
    tags: ['桌搭', '极简', '好物'],
    description: '一张让人专注的极简桌面是怎么搭出来的？分享我的桌搭思路与好物清单，告别杂乱无章。',
    views: 623000,
  },
  {
    id: 'short-14',
    title: '五分钟瑜伽拉伸',
    cover: 'https://readdy.ai/api/search-image?query=calm%20yoga%20thumbnail%20of%20a%20person%20stretching%20on%20a%20mat%20in%20a%20bright%20airy%20room%2C%20soft%20warm%20sunlight%2C%20serene%20wellness%20mood%2C%20minimal%20style&width=800&height=450&seq=st-14&orientation=landscape',
    duration: '05:20',
    uploadDate: '2025-09-22',
    category: 'short',
    categoryName: '短视频',
    region: '中国大陆',
    year: 2025,
    genre: '运动',
    tags: ['瑜伽', '拉伸', '减压'],
    description: '久坐一整天后的五分钟瑜伽拉伸，跟随呼吸放松肩颈与腰背，让紧绷的身体重新柔软下来。',
    views: 981000,
  },
  {
    id: 'short-15',
    title: '老物件修复记录',
    cover: 'https://readdy.ai/api/search-image?query=satisfying%20restoration%20thumbnail%20of%20an%20old%20rusty%20vintage%20object%20being%20cleaned%20on%20a%20workbench%2C%20before%20and%20after%20contrast%2C%20warm%20focused%20light&width=800&height=450&seq=st-15&orientation=landscape',
    duration: '11:15',
    uploadDate: '2025-09-21',
    category: 'short',
    categoryName: '短视频',
    region: '中国大陆',
    year: 2025,
    genre: '手工',
    tags: ['修复', '解压', '旧物'],
    description: '从锈迹斑斑到焕然一新，完整记录一件老物件的修复全过程，每一个细节都让人直呼治愈。',
    views: 1678000,
  },
  {
    id: 'short-16',
    title: '街头滑板集锦',
    cover: 'https://readdy.ai/api/search-image?query=dynamic%20skateboarding%20thumbnail%20of%20a%20skater%20performing%20a%20trick%20over%20urban%20stairs%20at%20golden%20hour%2C%20motion%20blur%2C%20warm%20orange%20light%2C%20energetic%20street%20style&width=800&height=450&seq=st-16&orientation=landscape',
    duration: '04:50',
    uploadDate: '2025-09-20',
    category: 'short',
    categoryName: '短视频',
    region: '美国',
    year: 2025,
    genre: '运动',
    tags: ['滑板', '街头', '集锦'],
    description: '本月最炸的街头滑板高光合集，翻板、呲杆、飞跃台阶，每一帧都肾上腺素飙升。',
    views: 726000,
  },
  {
    id: 'short-17',
    title: '一碗拉面的诞生',
    cover: 'https://readdy.ai/api/search-image?query=appetizing%20ramen%20thumbnail%20of%20a%20steaming%20bowl%20of%20ramen%20with%20rich%20broth%20and%20toppings%2C%20warm%20kitchen%20light%2C%20craftsmanship%20food%20photography%20mood&width=800&height=450&seq=st-17&orientation=landscape',
    duration: '13:25',
    uploadDate: '2025-09-19',
    category: 'short',
    categoryName: '短视频',
    region: '日本',
    year: 2025,
    genre: '美食',
    tags: ['拉面', '匠心', '纪录'],
    description: '从熬制八小时的汤底到手工打面，走进一家小店后厨，看一碗让人念念不忘的拉面如何诞生。',
    views: 894000,
  },
  {
    id: 'short-18',
    title: '旧相机翻新记',
    cover: 'https://readdy.ai/api/search-image?query=vintage%20camera%20thumbnail%20of%20a%20disassembled%20old%20film%20camera%20with%20lenses%20and%20tools%20on%20a%20warm%20wooden%20desk%2C%20soft%20directional%20light%2C%20craftsmanship%20mood&width=800&height=450&seq=st-18&orientation=landscape',
    duration: '10:05',
    uploadDate: '2025-09-18',
    category: 'short',
    categoryName: '短视频',
    region: '中国大陆',
    year: 2025,
    genre: '数码',
    tags: ['相机', '翻新', '复古'],
    description: '淘来一台六十年前的胶片相机，从拆解清洁到上弦试拍，让沉寂多年的老伙计重新按下快门。',
    views: 587000,
  },
  {
    id: 'short-19',
    title: '阳台种菜日记',
    cover: 'https://readdy.ai/api/search-image?query=fresh%20gardening%20thumbnail%20of%20lush%20green%20vegetables%20growing%20in%20pots%20on%20a%20sunny%20balcony%2C%20warm%20natural%20light%2C%20cheerful%20home%20garden%20mood&width=800&height=450&seq=st-19&orientation=landscape',
    duration: '09:30',
    uploadDate: '2025-09-17',
    category: 'short',
    categoryName: '短视频',
    region: '中国大陆',
    year: 2025,
    genre: '生活',
    tags: ['种菜', '阳台', '绿色'],
    description: '两平米阳台也能收获满满，记录从播种到采摘的三十天，教你轻松实现蔬菜自由。',
    views: 645000,
  },
  {
    id: 'short-20',
    title: '咖啡拉花艺术',
    cover: 'https://readdy.ai/api/search-image?query=beautiful%20latte%20art%20thumbnail%20of%20a%20barista%20pouring%20a%20rosetta%20pattern%20into%20a%20cup%2C%20close%20up%20crema%20detail%2C%20warm%20cafe%20lighting%2C%20artistic%20mood&width=800&height=450&seq=st-20&orientation=landscape',
    duration: '07:12',
    uploadDate: '2025-09-16',
    category: 'short',
    categoryName: '短视频',
    region: '意大利',
    year: 2025,
    genre: '生活',
    tags: ['拉花', '咖啡', '艺术'],
    description: '从心形到树叶再到天鹅，慢镜头解析咖啡拉花的每一次手腕发力，让一杯咖啡变成小小艺术。',
    views: 1036000,
  },

  {
    id: 'ent-01',
    title: '深夜脱口秀现场',
    cover: 'https://readdy.ai/api/search-image?query=comedy%20talk%20show%20thumbnail%20of%20a%20confident%20host%20on%20a%20warm%20lit%20stage%20with%20audience%20silhouettes%2C%20orange%20spotlight%2C%20entertaining%20energetic%20mood&width=800&height=450&seq=en-01&orientation=landscape',
    duration: '48:20',
    uploadDate: '2025-10-06',
    category: 'entertainment',
    categoryName: '娱乐',
    region: '中国大陆',
    year: 2025,
    genre: '脱口秀',
    tags: ['脱口秀', '搞笑', '现场'],
    description: '一群脱口秀演员用犀利又温柔的段子解构生活日常，把每一个狼狈瞬间都变成全场爆笑的理由。',
    views: 2210000,
  },
  {
    id: 'ent-02',
    title: '城市音乐节实录',
    cover: 'https://readdy.ai/api/search-image?query=music%20festival%20thumbnail%20of%20a%20crowd%20with%20raised%20hands%20in%20front%20of%20a%20glowing%20stage%20at%20night%2C%20warm%20orange%20lights%2C%20confetti%2C%20energetic%20festival%20mood&width=800&height=450&seq=en-02&orientation=landscape',
    duration: '1:12:40',
    uploadDate: '2025-10-05',
    category: 'entertainment',
    categoryName: '娱乐',
    region: '中国大陆',
    year: 2025,
    genre: '音乐',
    tags: ['音乐节', '现场', 'Live'],
    description: '城市音乐节三天实录精华，从黄昏的第一首歌到午夜的大合唱，带你重回那个热血沸腾的夜晚。',
    views: 1865000,
  },
  {
    id: 'ent-03',
    title: '喜剧之王挑战赛',
    cover: 'https://readdy.ai/api/search-image?query=comedy%20competition%20thumbnail%20of%20a%20lighting%20stage%20with%20a%20jester%20trophy%20and%20colorful%20spotlights%2C%20warm%20orange%20and%20gold%20accents%2C%20fun%20theatrical%20mood&width=800&height=450&seq=en-03&orientation=landscape',
    duration: '1:24:15',
    uploadDate: '2025-10-04',
    category: 'entertainment',
    categoryName: '娱乐',
    region: '中国大陆',
    year: 2025,
    genre: '综艺',
    tags: ['喜剧', '比赛', '爆笑'],
    description: '十八组喜剧人同台竞技，用创意、反转与即兴功力争夺年度喜剧之王的桂冠，笑点密集到停不下来。',
    views: 1654000,
  },
  {
    id: 'ent-04',
    title: '明星厨房大作战',
    cover: 'https://readdy.ai/api/search-image?query=fun%20cooking%20show%20thumbnail%20of%20colorful%20kitchen%20set%20with%20ingredients%20and%20pans%2C%20warm%20cheerful%20lighting%2C%20playful%20entertaining%20mood&width=800&height=450&seq=en-04&orientation=landscape',
    duration: '56:30',
    uploadDate: '2025-10-03',
    category: 'entertainment',
    categoryName: '娱乐',
    region: '中国大陆',
    year: 2025,
    genre: '综艺',
    tags: ['美食', '明星', '对决'],
    description: '明星嘉宾分组下厨限时对决，从翻车现场到惊艳出品，厨房里的每一次手忙脚乱都是笑料。',
    views: 1327000,
  },
  {
    id: 'ent-05',
    title: '街头魔术秀',
    cover: 'https://readdy.ai/api/search-image?query=street%20magic%20thumbnail%20of%20a%20magician%20performing%20a%20card%20trick%20to%20amazed%20passersby%20in%20a%20plaza%2C%20warm%20evening%20light%2C%20mysterious%20fun%20mood%2C%20shallow%20depth&width=800&height=450&seq=en-05&orientation=landscape',
    duration: '32:10',
    uploadDate: '2025-10-02',
    category: 'entertainment',
    categoryName: '娱乐',
    region: '美国',
    year: 2025,
    genre: '魔术',
    tags: ['魔术', '街头', '近景'],
    description: '世界级近景魔术师走上街头，用一张扑克牌和一枚硬币让路人瞠目结舌，见证奇迹发生的瞬间。',
    views: 1478000,
  },
  {
    id: 'ent-06',
    title: '舞蹈风暴半决赛',
    cover: 'https://readdy.ai/api/search-image?query=dance%20competition%20thumbnail%20of%20a%20dancer%20mid-leap%20on%20a%20dark%20stage%20with%20dramatic%20warm%20spotlight%2C%20motion%20captured%2C%20elegant%20powerful%20mood&width=800&height=450&seq=en-06&orientation=landscape',
    duration: '1:38:50',
    uploadDate: '2025-10-01',
    category: 'entertainment',
    categoryName: '娱乐',
    region: '中国大陆',
    year: 2025,
    genre: '舞蹈',
    tags: ['舞蹈', '竞技', '高能'],
    description: '八强舞者向决赛名额发起冲击，现代舞、国标与街舞轮番上阵，用身体语言讲述最动人的故事。',
    views: 1592000,
  },
  {
    id: 'ent-07',
    title: '综艺真心话大冒险',
    cover: 'https://readdy.ai/api/search-image?query=fun%20game%20show%20thumbnail%20of%20colorful%20game%20set%20with%20spinning%20wheel%20and%20props%2C%20warm%20playful%20lighting%2C%20cheerful%20entertaining%20mood&width=800&height=450&seq=en-07&orientation=landscape',
    duration: '45:00',
    uploadDate: '2025-09-30',
    category: 'entertainment',
    categoryName: '娱乐',
    region: '中国大陆',
    year: 2025,
    genre: '综艺',
    tags: ['游戏', '互动', '搞笑'],
    description: '明星团建玩起真心话大冒险，意想不到的提问与惩罚让现场笑成一片，友情的小船说翻就翻。',
    views: 1183000,
  },
  {
    id: 'ent-08',
    title: '音乐现场：夏夜之声',
    cover: 'https://readdy.ai/api/search-image?query=acoustic%20music%20live%20thumbnail%20of%20a%20singer%20with%20guitar%20on%20a%20warm%20lit%20intimate%20stage%2C%20amber%20string%20lights%2C%20cozy%20romantic%20concert%20mood&width=800&height=450&seq=en-08&orientation=landscape',
    duration: '58:40',
    uploadDate: '2025-09-29',
    category: 'entertainment',
    categoryName: '娱乐',
    region: '中国大陆',
    year: 2025,
    genre: '音乐',
    tags: ['Live', '民谣', '治愈'],
    description: '一场只属于夏夜的民谣音乐会，歌手抱着吉他轻声吟唱，把城市的喧嚣都留在了门外。',
    views: 976000,
  },
  {
    id: 'ent-09',
    title: '搞笑短剧合集',
    cover: 'https://readdy.ai/api/search-image?query=sketch%20comedy%20thumbnail%20of%20expressive%20actors%20in%20a%20bright%20colorful%20set%2C%20warm%20cheerful%20lighting%2C%20funny%20dramatic%20theatrical%20mood&width=800&height=450&seq=en-09&orientation=landscape',
    duration: '28:15',
    uploadDate: '2025-09-28',
    category: 'entertainment',
    categoryName: '娱乐',
    region: '中国大陆',
    year: 2025,
    genre: '喜剧',
    tags: ['短剧', '搞笑', '反转'],
    description: '精选本月最好笑的十个短剧桥段，每一个都有让人意想不到的反转，通勤路上笑到停不下来。',
    views: 2043000,
  },
  {
    id: 'ent-10',
    title: '才艺对决之夜',
    cover: 'https://readdy.ai/api/search-image?query=talent%20show%20thumbnail%20of%20a%20dramatic%20stage%20with%20glowing%20orange%20spotlights%20and%20silhouetted%20performer%2C%20grand%20theatrical%20competition%20mood&width=800&height=450&seq=en-10&orientation=landscape',
    duration: '1:05:20',
    uploadDate: '2025-09-27',
    category: 'entertainment',
    categoryName: '娱乐',
    region: '中国大陆',
    year: 2025,
    genre: '综艺',
    tags: ['才艺', '竞技', '舞台'],
    description: '来自各行各业的素人选手走上舞台展示隐藏才艺，歌声、乐器与绝技轮番登场，让人眼前一亮。',
    views: 1128000,
  },
  {
    id: 'ent-11',
    title: '旅行真人秀：山野篇',
    cover: 'https://readdy.ai/api/search-image?query=travel%20reality%20show%20thumbnail%20of%20hikers%20on%20a%20mountain%20trail%20at%20sunrise%20with%20mist%20in%20valleys%2C%20warm%20golden%20light%2C%20adventurous%20warm%20mood&width=800&height=450&seq=en-11&orientation=landscape',
    duration: '1:18:45',
    uploadDate: '2025-09-26',
    category: 'entertainment',
    categoryName: '娱乐',
    region: '中国大陆',
    year: 2025,
    genre: '真人秀',
    tags: ['旅行', '真人秀', '治愈'],
    description: '几位嘉宾放下工作走进山野，徒步、野炊、夜聊星空，在慢下来的旅程里找回生活原本的模样。',
    views: 1356000,
  },
  {
    id: 'ent-12',
    title: '配音大挑战',
    cover: 'https://readdy.ai/api/search-image?query=voice%20acting%20thumbnail%20of%20a%20person%20at%20a%20microphone%20in%20a%20warm%20lit%20studio%20booth%20with%20headphones%2C%20focused%20expressive%20mood%2C%20soft%20orange%20light&width=800&height=450&seq=en-12&orientation=landscape',
    duration: '52:30',
    uploadDate: '2025-09-25',
    category: 'entertainment',
    categoryName: '娱乐',
    region: '中国大陆',
    year: 2025,
    genre: '综艺',
    tags: ['配音', '挑战', '声控'],
    description: '嘉宾挑战为经典影视片段现场配音，一人分饰多角，用声音带你重新体验那些名场面。',
    views: 863000,
  },
  {
    id: 'ent-13',
    title: '音乐剧《星光》',
    cover: 'https://readdy.ai/api/search-image?query=musical%20theatre%20thumbnail%20of%20a%20grand%20stage%20with%20dancers%20and%20warm%20golden%20spotlights%2C%20elegant%20costumes%2C%20dramatic%20romantic%20broadway%20mood&width=800&height=450&seq=en-13&orientation=landscape',
    duration: '2:15:00',
    uploadDate: '2025-09-24',
    category: 'entertainment',
    categoryName: '娱乐',
    region: '英国',
    year: 2024,
    genre: '音乐剧',
    tags: ['音乐剧', '舞台', '艺术'],
    description: '一部关于追梦与坚持的原创音乐剧，少年在聚光灯下唱出心中最亮的星光，谢幕时全场起立鼓掌。',
    views: 742000,
  },
  {
    id: 'ent-14',
    title: '脱口秀新人赛',
    cover: 'https://readdy.ai/api/search-image?query=standup%20comedy%20thumbnail%20of%20a%20young%20comedian%20with%20microphone%20on%20a%20bar%20stage%2C%20warm%20orange%20spotlight%2C%20intimate%20lively%20mood%2C%20shallow%20depth&width=800&height=450&seq=en-14&orientation=landscape',
    duration: '42:50',
    uploadDate: '2025-09-23',
    category: 'entertainment',
    categoryName: '娱乐',
    region: '中国大陆',
    year: 2025,
    genre: '脱口秀',
    tags: ['脱口秀', '新人', '开放麦'],
    description: '十二位素人新人的开放麦首秀，有人紧张到忘词，有人一鸣惊人，真实又可爱的追梦现场。',
    views: 689000,
  },
  {
    id: 'ent-15',
    title: '舞蹈教室幕后',
    cover: 'https://readdy.ai/api/search-image?query=dance%20rehearsal%20thumbnail%20of%20dancers%20practicing%20in%20a%20bright%20studio%20with%20mirrors%2C%20warm%20natural%20light%2C%20passionate%20dedicated%20mood&width=800&height=450&seq=en-15&orientation=landscape',
    duration: '38:20',
    uploadDate: '2025-09-22',
    category: 'entertainment',
    categoryName: '娱乐',
    region: '中国大陆',
    year: 2025,
    genre: '舞蹈',
    tags: ['幕后', '舞蹈', '记录'],
    description: '镜头跟随一群舞者走进排练厅，记录舞台上每一个完美瞬间背后，无数次摔倒与重来的坚持。',
    views: 574000,
  },
  {
    id: 'ent-16',
    title: '喜剧小品精选',
    cover: 'https://readdy.ai/api/search-image?query=comedy%20sketch%20thumbnail%20of%20colorful%20stage%20with%20comedians%20in%20costumes%2C%20warm%20festive%20lighting%2C%20joyful%20theatrical%20gala%20mood&width=800&height=450&seq=en-16&orientation=landscape',
    duration: '1:32:10',
    uploadDate: '2025-09-21',
    category: 'entertainment',
    categoryName: '娱乐',
    region: '中国大陆',
    year: 2025,
    genre: '喜剧',
    tags: ['小品', '精选', '合家欢'],
    description: '精选近年人气喜剧小品，从生活琐事到社会热点，用幽默化解烦恼，全家一起看的欢乐时光。',
    views: 1523000,
  },
  {
    id: 'ent-17',
    title: '演播厅探班日记',
    cover: 'https://readdy.ai/api/search-image?query=tv%20studio%20behind%20the%20scenes%20thumbnail%20of%20cameras%20and%20a%20warm%20lit%20set%20with%20crew%20working%2C%20orange%20accent%20lighting%2C%20documentary%20mood&width=800&height=450&seq=en-17&orientation=landscape',
    duration: '35:45',
    uploadDate: '2025-09-20',
    category: 'entertainment',
    categoryName: '娱乐',
    region: '中国大陆',
    year: 2025,
    genre: '纪录片',
    tags: ['幕后', '探班', '花絮'],
    description: '走进热门综艺的演播厅后台，看看一档节目从彩排到录制的完整一天，感受幕后的忙碌与欢乐。',
    views: 498000,
  },
  {
    id: 'ent-18',
    title: '音乐电台深夜档',
    cover: 'https://readdy.ai/api/search-image?query=late%20night%20radio%20thumbnail%20of%20a%20host%20in%20a%20warm%20lit%20studio%20with%20vinyl%20records%2C%20soft%20amber%20glow%2C%20intimate%20calm%20night%20mood&width=800&height=450&seq=en-18&orientation=landscape',
    duration: '49:30',
    uploadDate: '2025-09-19',
    category: 'entertainment',
    categoryName: '娱乐',
    region: '中国台湾',
    year: 2025,
    genre: '音乐',
    tags: ['电台', '深夜', '陪伴'],
    description: '深夜十二点，电台主持人用一首首老歌和温暖的故事，陪伴每一个还没睡着的城市夜归人。',
    views: 436000,
  },
  {
    id: 'ent-19',
    title: '魔术揭秘特辑',
    cover: 'https://readdy.ai/api/search-image?query=magic%20revealed%20thumbnail%20of%20props%20and%20cards%20on%20a%20dark%20table%20with%20warm%20spotlight%2C%20mysterious%20curious%20mood%2C%20dramatic%20shadows&width=800&height=450&seq=en-19&orientation=landscape',
    duration: '41:15',
    uploadDate: '2025-09-18',
    category: 'entertainment',
    categoryName: '娱乐',
    region: '美国',
    year: 2025,
    genre: '魔术',
    tags: ['揭秘', '魔术', '教学'],
    description: '资深魔术师首次公开经典魔术背后的原理与手法，看完你也能在朋友面前变上两手。',
    views: 934000,
  },
  {
    id: 'ent-20',
    title: '全民才艺盛典',
    cover: 'https://readdy.ai/api/search-image?query=grand%20talent%20gala%20thumbnail%20of%20a%20large%20stage%20with%20warm%20golden%20spotlights%20and%20confetti%2C%20performers%20silhouettes%2C%20festive%20celebratory%20mood&width=800&height=450&seq=en-20&orientation=landscape',
    duration: '1:45:00',
    uploadDate: '2025-09-17',
    category: 'entertainment',
    categoryName: '娱乐',
    region: '中国大陆',
    year: 2025,
    genre: '综艺',
    tags: ['盛典', '才艺', '颁奖'],
    description: '年度才艺盛典汇聚全年最亮眼的素人选手，歌舞与绝技同台绽放，为热爱与坚持送上最热烈的掌声。',
    views: 1284000,
  },
];

export const categoryList = [
  {
    key: 'movie',
    name: '电影',
    icon: 'ri-film-line',
    desc: '精选院线大片与经典佳作，从科幻到剧情，一次看个够。',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20collage%20of%20movie%20genres%20with%20warm%20orange%20lighting%20and%20film%20strip%20elements%2C%20dramatic%20theatrical%20atmosphere%2C%20rich%20detail&width=800&height=600&seq=cat-movie&orientation=landscape',
  },
  {
    key: 'short',
    name: '短视频',
    icon: 'ri-video-line',
    desc: '美食、手工、数码、生活技巧，用碎片时间收获满满干货。',
    cover: 'https://readdy.ai/api/search-image?query=bright%20collage%20of%20short%20video%20topics%20like%20food%20craft%20and%20lifestyle%20with%20warm%20cheerful%20colors%2C%20modern%20vibrant%20design&width=800&height=600&seq=cat-short&orientation=landscape',
  },
  {
    key: 'entertainment',
    name: '娱乐',
    icon: 'ri-mic-line',
    desc: '综艺、音乐、脱口秀与舞台现场，轻松时刻必备的快乐源泉。',
    cover: 'https://readdy.ai/api/search-image?query=vibrant%20collage%20of%20entertainment%20stage%20shows%2C%20music%20and%20comedy%20with%20warm%20golden%20spotlights%2C%20festive%20joyful%20atmosphere&width=800&height=600&seq=cat-ent&orientation=landscape',
  },
];